import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";

export default function Praedikener() {
    return (
        <EditPage apiPath="page/Praedikener">
            <PageHeaderEdit sectionKey="PageHeader" />
        </EditPage>
    );
}